import { Form, Input } from '@heathmont/moon-core-tw';
import { useDropzone } from 'react-dropzone';
import useTranslation from '~/client/hooks/i18n/useTranslation';
import sendInteractionToGtm from '~/shared/gtm/sendInteractionToGtm';
import FileInfo from './FileInfo';
import GenericUpload from '@/external/icons/GenericUpload';

type Props = {
  onDrop: (item: File[]) => void;
};

const FileUploader: FC<Props> = ({ onDrop }) => {
  const placeholder = useTranslation('support.adding_files_is_optional');
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop,
  });
  const sendToGtm = () =>
    sendInteractionToGtm({
      eventCategory: 'file_input_field',
      eventAction: 'contact_support',
    });

  return (
    <div className="grid gap-4" {...getRootProps()} onClick={sendToGtm}>
      <Form.Item>
        <Input
          type="file"
          placeholder={placeholder}
          {...getInputProps({ id: 'files' })}
          className="text-bulma file:hidden"
          style={{ display: 'grid', cursor: 'pointer' }}
        />
        <GenericUpload className="relative bottom-7 z-10 ml-auto mr-4 text-moon-20" />
      </Form.Item>
      {acceptedFiles.map((file, index) => (
        <FileInfo key={file?.name} file={file} position={index + 1} />
      ))}
    </div>
  );
};

export default FileUploader;
